// The Comic Machine - Layer Input

var LayerInput = (function() {

  // A layer iput item instance for the LayerListItem
  function LayerInput(options) {

    options = options || {};

    var input = this;

    this.element = options.element;
    this.object = options.object;
    this.property = options.property;
    this.callback = options.callback;
    this.onInput = options.onInput;
    this.handler = options.handler;

    this.element.addEventListener("change", this, true);
    this.element.addEventListener("keyup", this, true);

    this.object.bindWatch(this.property, function(id, previous, current) {
      return input.value = current;
    });

    Object.defineProperty(this, "value", {
      enumerable: true,
      get: function() {
        return input.element.value;
      },
      set: function(value) {
        input.element.value = value;
        input.callback && input.callback(value);
      }
    });

    this.value = this.object[this.property];

  }

  // Method to handle change events
  LayerInput.prototype.handleEvent = function(event) {

    var value = this.element.value;

    if (this.element.type === "number") {
      value = window.parseFloat(value);
    }

    if (event.type === "change" || event.type === "keyup") {
      this.onInput && this.onInput(value);
      input.handler && input.handler(value);
      this.object[this.property] = value;
    }

  };

  // Public / exposed class
  return LayerInput;

})();
